<template>
    <div class="rounded-corners position-relative border"
         :class="{ 'border-secondary': disabled,
            'border-info': !disabled,
            'text-secondary': disabled,
            'text-info': !disabled,
            'gallery-add-thumbnail': !disabled
        }"
         @click="onClick"
         :style="{
            width: getWidth + 'px',
            height: getHeight + 'px',
            cursor: disabled ? 'default' : 'pointer',
         }">


        <slot name="icon">
            <div class="d-flex w-100 h-100 align-items-center justify-content-center">
                <span class="h1"><b-icon icon="plus"/></span>
            </div>
        </slot>
        <div>
            <form :ref="formReference">
                <input class="form-control d-none"
                       :ref="inputReference"
                       multiple
                       type="file"
                       :accept="inputAccept"
                       @change="onChange">
            </form>
        </div>
    </div>
</template>

<script>
    import httpClient from "../../http";
    import { UploadedFile } from "./file";
    import mime from 'mime-types';

    export default {
        name: "GalleryAddThumbnail",
        props: {
            initialUploadUrl: { type: String, default: null },
            size: { type: Number, default: 200 },
            kind: { type: Number, default: 2 },  // Изображения могут быть частью галереи или среди документов
            width: { type: Number, default: 200 },
            height: { type: Number, default: 200 },
            prefix: { type: String, default: '' },
            maxFiles: { type: Number },
            maxSize: { type: Number },
            accepts: { type: Array, default: () => { return [] } },
            disabled: { type: Boolean, default: false },
            uploadImmediately: { type: Boolean, default: true },
        },
        data() {
            return {
                _uploadUrl: null
            }
        },
        computed: {
            formReference() { return this.prefix + 'gallery' },
            inputReference() { return this.prefix + 'uploadInput' },
            uploadUrl: {
                get: function () {
                    if (!this._uploadUrl) {
                        return this.initialUploadUrl
                    }
                    return this._uploadUrl
                },
                set: function (value) {
                    this._uploadUrl = value;
                }
            },
            getWidth() {
                return this.width > 0 ? this.width : this.size
            }
            ,
            getHeight() {
                return this.height > 0 ? this.height : this.size
            },
            inputAccept() {
                return this.accepts.length > 0 ? this.accepts.join(', ') : ''
            }
        },
        methods: {
            onClick() {
                if (!this.disabled) {
                    this.$refs[this.inputReference].click();
                }
            },
            async onChange() {
                let toBeUploaded = [...this.$refs[this.inputReference].files];
                let newFiles = [];
                let typeMismatched = [];
                let size = 0;
                let sizeExceeded = [];

                for (const i in toBeUploaded) {
                    const f = toBeUploaded[i];
                    let canAdd = true;
                    size += f.size;
                    if (size >= this.maxSize) {
                        sizeExceeded.push(f.name);
                        continue
                    }
                    if (this.accepts.length && this.accepts.indexOf(mime.lookup(f.name)) < 0) {
                        canAdd = false;
                    }
                    if (canAdd) { newFiles.push(f); }
                    else { typeMismatched.push(f.name); }
                }

                if (sizeExceeded.length) {
                    this.$emit('files-size-exceeded', { fileNames: sizeExceeded })
                }

                if (typeMismatched.length) {
                    this.$emit('files-type-mismatched', { fileNames: typeMismatched })
                }

                if (this.maxFiles && newFiles.length > this.maxFiles) {
                    let excess = [];
                    for (let i = this.maxFiles; i < newFiles.length; i++) {
                        excess.push(newFiles[i].name);
                    }
                    newFiles = newFiles.splice(0, this.maxFiles);
                    this.$emit('files-excess', { fileNames: excess })
                }
                await this.addFiles(newFiles);
            },
            async addFiles(newFiles) {

                for (const i in newFiles) {
                    const f = newFiles[i];
                    const fo = new UploadedFile(null, null, f, null, false, f.size);
                    if (this.uploadImmediately) {
                        await this.upload(fo);
                    } else {
                        this.$emit('file-buffered', fo);
                    }
                }
                this.$refs[this.formReference].reset();
            },
            async upload(file) {
                const vm = this;
                let formData = new FormData();
                formData.append('kind', this.kind);
                formData.append('file', file.file);

                vm.$emit('file-started-uploading', file);
                const response = await httpClient
                    .post(vm.uploadUrl, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .catch(() => {
                        const error = 'Ошибка при загрузке'
                        vm.$emit('file-uploaded', { error: error, uuid: file.uuid });
                    });
                file.serverSide = true;
                vm.$emit('file-uploaded', { response: response.data, uuid: file.uuid });
                return response.data;
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .gallery-add-thumbnail {
        &:hover {
            background-color: $info;
            color: $light !important;
        }
    }
</style>